import { InjectionToken, inject } from '@angular/core';
import { ApiClient, injectApiClient } from '@open/ngx-api';
import { OnCallContracts } from '@assets/api/onCallContracts';

type BusinessCalls = Pick<OnCallContracts,
  | 'AUTH-checkIsActivatedUser_onCall'
  | 'AUTH-checkUserPinValidity_onCall'
  | 'AUTH-createPinForUser_onCall'
  | 'AUTH-loginForUserWithPin_onCall'
  | 'BUSINESSES-addBusinessUser_onCall'
  | 'BUSINESSES-editBusinessUser_onCall'
  | 'BUSINESSES-getBusinessInternalInformations_onCall'
  | 'BUSINESSES-getBusinessMonthlyOverview_onCall'
  | 'BUSINESSES-getBusinessOpenPayoutIban_onCall'
  | 'BUSINESSES-getContractedAgenciesOfBusiness_onCall'
  | 'BUSINESSES-getOneBusinessInvoices_onCall'
  | 'BUSINESSES-listAllBusinessesOfBusinessAdmin_onCall'
  | 'BUSINESSES-listBusinessUsers_onCall'
  | 'BUSINESSES-sendBusinessUserPasswordReset_onCall'
  | 'BUSINESSES-setBusinessOpenPayoutIban_onCall'
  | 'BUSINESSES-updateBusinessInternalInformations_onCall'
  | 'CHORUS_PRO-submitBusinessInvoice_onCall'
  | 'DISCRETE_VOUCHERS-generateBusinessVouchersInvoice_onCall'
  | 'DISCRETE_VOUCHERS-getBusinessMonthlyVoucherSummary_onCall'
  | 'DISCRETE_VOUCHERS-listBusinessMonthlyVoucherReports_onCall'
  | 'MERCHANT_NETWORKS-acceptUnionAgreement_onCall'
  | 'MERCHANT_NETWORKS-getConventionRequestForm_onCall'
  | 'MERCHANT_NETWORKS-getUnionAgreement_onCall'
  | 'MERCHANT_NETWORKS-getUnionDashboard_onCall'
  | 'MERCHANT_NETWORKS-listMyMerchantNetworks_onCall'
  | 'MERCHANT_NETWORKS-listUnionAgreements_onCall'
  | 'MERCHANT_NETWORKS-reactivateUnionAgreement_onCall'
  | 'MERCHANT_NETWORKS-recreateUnionAgreementAccount_onCall'
  | 'MERCHANT_NETWORKS-rejectUnionAgreement_onCall'
  | 'MERCHANT_NETWORKS-resendUnionAgreementEmail_onCall'
  | 'MERCHANT_NETWORKS-searchConventionEstablishment_onCall'
  | 'MERCHANT_NETWORKS-submitMerchantAgreementRequest_onCall'
  | 'MERCHANT_NETWORKS-suspendUnionAgreement_onCall'
  | 'MERCHANT_NETWORKS-terminateUnionAgreement_onCall'
>;

export type BusinessApi = ApiClient<BusinessCalls>;

// Token-backed so specs can `{ provide: BUSINESS_API, useValue: stub }`.
export const BUSINESS_API: InjectionToken<BusinessApi> = new InjectionToken<BusinessApi>('BUSINESS_API', {
  providedIn: 'root',
  factory: (): BusinessApi => injectApiClient<BusinessCalls>(),
});

export function injectApi(): BusinessApi {
  return inject(BUSINESS_API);
}
